module.exports = __webpack_public_path__ + "img/20191211163312360截图20191211162229505.aaa6e21f.jpg";